import { Row, Col, Divider } from 'antd';
import { Link } from 'react-router-dom';
import { ArrowLeftOutlined } from '@ant-design/icons';
import { useEffect } from 'react';
import { useNavigate as useHistory } from 'react-router-dom';

function RicercaStoriaUABox({ defaultSkip, queryString }) {
  const history = useHistory();

  useEffect(() => {
    if (defaultSkip) defaultSkip(true);
    if (queryString) queryString('');
    document.title = 'Cambiamenti delle unità territoriali - SITUAS';
  });

  return (
    <main id="main-content" className={`pb-4 pt-3 pb-4 bs-docs-section clearfix`}>
      <button
        tabIndex="0"
        id="returnButton"
        aria-label='Torna indietro'
        onClick={() => {
          history(`/home`);
        }}>
        <ArrowLeftOutlined aria-label={null} />
        <span>Indietro</span>
      </button>

      <Row className="box">
        <Col xs={24}>
          <h2 className="title-main">Cambiamenti delle unità territoriali</h2>
          <Divider className="blue-divider" />
          <div>
            A supporto dell’informazione statistica per cittadini e istituzioni, l’Istat raccoglie e documenta i
            cambiamenti che interessano il territorio italiano.
          </div>
          <div
            className={`d-flex mt-2 pt-2 codifiche row`}
            style={{ columnGap: '15px', rowGap: '10px', margin: '0' }}>
            <div
              className="card d-flex flex-column col">
              Per approfondimenti sulle tipologie di cambiamento e dettagli su estremi normativi e variazioni:
              <div className="mt-auto">
              <Link className="box-linkto" to="/storia_ua">
                Vai alla sezione Storia unità territoriali
              </Link>
              </div>
            </div>
            <div
              className="card d-flex flex-column col">
              Per approfondimenti su codici e denominazioni assunti nel tempo dalle unità territoriali:
              <div className="mt-auto">
                <Link className="box-linkto" to="/ricerca-codice">
                  Vai alla sezione Ricerca codice Istat
                </Link>
              </div>
            </div>
          </div>
        </Col>
      </Row>
    </main>
  );
}
export default RicercaStoriaUABox;
